const hostEnvironmentMap = {
    'bodylytix.ai': 'prod',
    'www.bodylytix.ai': 'prod',
    'bodylytix.web-magic.space': 'qa',
    'www.bodylytix.web-magic.space': 'qa',
};

const resolveEnvironment = () => {
    // Prefer explicit env var; otherwise infer from host so the correct endpoint set is selected automatically
    if (process.env.REACT_APP_ENV) {
        return process.env.REACT_APP_ENV;
    }

    if (typeof window !== 'undefined') {
        const mappedEnv = hostEnvironmentMap[window.location.hostname];
        if (mappedEnv) {
            return mappedEnv;
        }
    }

    return 'qa';
};

const environment = resolveEnvironment();

export default environment;
